export const COLOR = {
  PH: '#EBEBEB',
  bgColor: '#f5f5f5',
  bgColorVariant: '#f6f7f8',
  borderColor: '#d3d3d3',
  textColor: '#232323',
  helperTextColor: '#999',
  linkColor: '#4294ff',
  linkColor2: '#1270ec',
  statusTextColor: '#d32f2f',
  subTitleColor: '#626465',
  titleColor: '#e00000',
  blackColor: '#000000',
  whiteTextColor: '#ffffff',
  lightBlackColor: '#000000a3',
  formText: '#505050',
  menuItemColor: '#2b2d2e',
  errorTextColor: 'red',
};
